export const INSERT_SEARCH_FILTER = 'INSERT_SEARCH_FILTER'

export const CLEAR_SEARCH_FILTER = 'CLEAR_SEARCH_FILTER'

export const UN_SEARCH_FILTER = 'UN_SEARCH_FILTER'
